import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["magicLinkButton", "magicLinkIcon"]
  static values = { 
    toastDuration: { type: Number, default: 2000 }
  }

  sendMagicLink(event) {
    event.preventDefault()
    const form = event.currentTarget
    const formData = new FormData(form)
    const data = Object.fromEntries(formData)
    
    // Disable the button immediately
    this.magicLinkButtonTarget.classList.add("btn-disabled")

    fetch(form.action, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify(data)
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json()
    })
    .then(data => {
      if (data.message) {
        // Success state
        this.magicLinkButtonTarget.classList.remove("btn-ghost", "btn-error")
        this.magicLinkButtonTarget.classList.add("btn-success")
        this.magicLinkIconTarget.setAttribute("icon", "ph:check-circle")
        this.magicLinkButtonTarget.querySelector("span").textContent = "Link Sent"
      }
    })
    .catch(error => {
      console.error("Error:", error)
      // Error state
      this.magicLinkButtonTarget.classList.remove("btn-ghost", "btn-success")
      this.magicLinkButtonTarget.classList.add("btn-error")
      this.magicLinkIconTarget.setAttribute("icon", "ph:x-circle")
      this.magicLinkButtonTarget.querySelector("span").textContent = "Error"
      // Re-enable the button on error so they can try again
      this.magicLinkButtonTarget.classList.remove("btn-disabled")
    })
  }

  copyToClipboard(event) {
    event.preventDefault()
    const button = event.currentTarget
    const textToCopy = button.dataset.ambassadorDetailsTextParam
    
    // Copy to clipboard
    navigator.clipboard.writeText(textToCopy).then(() => {
      // Show success feedback
      const originalIcon = button.querySelector('iconify-icon').getAttribute('icon')
      button.querySelector('iconify-icon').setAttribute('icon', 'ph:check')
      button.classList.add('btn-success')
      
      // Create toast notification
      this.showToast('Link copied to clipboard!')
      
      // Reset after a short delay
      setTimeout(() => {
        button.querySelector('iconify-icon').setAttribute('icon', originalIcon)
        button.classList.remove('btn-success')
      }, this.toastDurationValue)
    }).catch(err => {
      console.error('Failed to copy: ', err)
      this.showToast('Failed to copy link', 'error')
    })
  }

  showToast(message, type = 'success') {
    // Create toast element
    const toast = document.createElement('div')
    toast.className = `toast toast-end`
    toast.innerHTML = `
      <div class="alert alert-${type}">
        <span>${message}</span>
      </div>
    `
    
    // Add to DOM
    document.body.appendChild(toast)
    
    // Remove after duration
    setTimeout(() => {
      toast.remove()
    }, this.toastDurationValue)
  }
} 